import {
  CreateHabitatInput,
  Habitat,
  UpdateHabitatInput,
} from '@akin-home/amplify';
import { notNull } from '@akin-home/arrays';
import { HabitatModel, createHabitatModel } from '@akin-home/habitats';

export const formatHabitatToModel = (item: Habitat): HabitatModel =>
  createHabitatModel({
    id: item.id as string,
    habitatID: item.habitatID as string,
    image: notNull(item.image),
    imageUrl: item.imageURL || undefined,
    favouriteRecipeIDs: (item.favouriteRecipeIDs || []) as string[],
  });

export const habitatModelToUpdateGraphql = (
  habitat: HabitatModel
): UpdateHabitatInput => ({
  id: habitat.id,
  imageID: habitat.image?.id,
  imageURL: habitat.imageUrl,
  favouriteRecipeIDs: habitat.favouriteRecipeIDs,
});

export const habitatModelToCreateGraphql = (
  habitat: HabitatModel
): CreateHabitatInput => ({
  habitatID: habitat.habitatID,
  imageID: habitat.image?.id,
  imageURL: habitat.imageUrl,
  favouriteRecipeIDs: habitat.favouriteRecipeIDs,
});
